import React from 'react';

function Insights() {
  return (
    <div className="insights-container">
      <div className="insights-header">
        <h2>B/CORE Insights</h2>
        <p>AI-powered analytics for your contract portfolio. Ask questions, get answers.</p>
      </div>

      <div className="insights-suggestions">
        <div className="suggestion-card">
          <div className="suggestion-card-icon">&#x1F4CA;</div>
          <div className="suggestion-card-title">Portfolio Risk Analysis</div>
          <div className="suggestion-card-desc">Analyze risk across all active contracts and identify potential issues before they escalate.</div>
        </div>

        <div className="suggestion-card">
          <div className="suggestion-card-icon">&#x1F4B0;</div>
          <div className="suggestion-card-title">Spend Forecasting</div>
          <div className="suggestion-card-desc">Project future spend based on current burn rates and contract ceilings.</div>
        </div>

        <div className="suggestion-card">
          <div className="suggestion-card-icon">&#x1F6E1;</div>
          <div className="suggestion-card-title">Compliance Review</div>
          <div className="suggestion-card-desc">Check compliance status across partners and identify gaps in certifications.</div>
        </div>

        <div className="suggestion-card">
          <div className="suggestion-card-icon">&#x1F465;</div>
          <div className="suggestion-card-title">Personnel Planning</div>
          <div className="suggestion-card-desc">Optimize staffing across contracts based on clearance levels and skill requirements.</div>
        </div>
      </div>

      <div className="insights-footer">
        <div className="insights-input-row">
          <input
            type="text"
            className="insights-input"
            placeholder="Ask a question about your contracts, personnel, or compliance..."
          />
          <button className="btn btn-primary">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="22" y1="2" x2="11" y2="13" />
              <polygon points="22 2 15 22 11 13 2 9 22 2" />
            </svg>
          </button>
        </div>
        <div className="insights-link">
          Powered by <span style={{ color: 'var(--bcore-accent)' }}>AWS Bedrock</span> &mdash; Coming Soon
        </div>
      </div>
    </div>
  );
}

export default Insights;
